import { FieldSlugEnum } from 'common/enums/FieldSlugEnum'
import EntityTypeEnum from 'common/enums/entityTypeEnum'
import { MasterBlockId } from 'common/types/entities/EntityInterface'
import { BorderStyleEnum } from 'common/types/styleTypes'
import {
  generateHtmlAttrId,
  generateId,
} from 'src/shared/entities/utils/generate-base-entity'

export function createAttachments(
  parentId: string,
  masterBlockId?: MasterBlockId,
) {
  const attachments = {
    id: generateId(),
    type: EntityTypeEnum.Attachments,
    parentId: parentId,
    masterBlockId: masterBlockId,
    show: false,
    alignSelf: 'flex-start',
    iconClassName: 'far fa-paperclip',
    fontSize: 20,
    color: 'rgba(255, 255, 255, 1)',
    backgroundColor: 'rgba(1, 160, 255, 1)',
    slug: FieldSlugEnum.Attachments,
    border: {
      radius: 5,
      style: BorderStyleEnum.none,
    },
    appearance: {
      desktop: true,
      mobile: true,
    },
    padding: {
      paddingTop: 10,
      paddingRight: 10,
      paddingBottom: 10,
      paddingLeft: 10,
    },
    margin: {
      marginTop: 0,
      marginRight: 0,
      marginBottom: 15,
      marginLeft: 0,
    },
    mobileMargin: {
      marginTop: 0,
      marginRight: 0,
      marginBottom: 0,
      marginLeft: 0,
    },
    htmlAttrId: generateHtmlAttrId(EntityTypeEnum.Attachments),
  }

  return attachments
}
